import React, {lazy, Suspense} from 'react';
import {Routes, Route, useNavigate, Navigate} from 'react-router-dom';
import {Security, LoginCallback} from '@okta/okta-react';
import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';
import LoginComponent from './components/Login/LoginComponent';
import {PrivateRoutes} from './components/Okta/PrivateRoutes';
import './App.css';
import {oktaConfig} from '../src/components/Okta/oktaConfig';
import LoadingScreen from './components/Loader';

// Route-level code splitting: each heavy route is fetched only when the user
// navigates to it. Keeps the initial bundle small.
const Home = lazy(() => import('./components/Home/Home'));
const Dashboard = lazy(() => import('./components/Dashboard/Dashboard'));
const SpendWiseGenieChat = lazy(() => import('./pages/ChatGenie'));
const HomeV2 = lazy(
  () => import(/* webpackPrefetch: true */ './v2/pages/Home'),
);
const Layout = lazy(() => import('./v2/components/layouts/Layout'));
// const ChatFullScreen = lazy(
//   () => import(/* webpackPrefetch: true */ './v2/pages/ChatFullScreen'),
// );

const oktaAuth = new OktaAuth(oktaConfig);

const RoutesApp = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route
            path={'/dashboard'}
            element={<Dashboard />}
          />
          <Route
            path='/chatGenie'
            element={<SpendWiseGenieChat />}
          />
          <Route element={<Layout />}>
            <Route
              path='/home'
              element={<HomeV2 />}
            />
            {/* <Route
              path={'/chat'}
              element={<ChatFullScreen />}
            /> */}
          </Route>
        </Route>
        <Route
          path={'/signup'}
          element={<LoginComponent />}
        />
        <Route
          path='/login'
          element={<LoginCallback />}
        />
        <Route
          path='*'
          element={<Navigate to={'/home'} />}
        />
      </Routes>
    </Suspense>
  );
};

const App = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
    navigate(toRelativeUrl(originalUri || '/home', globalThis.location.origin));
  };
  return (
    <Security
      restoreOriginalUri={restoreOriginalUri}
      oktaAuth={oktaAuth}
    >
      <RoutesApp />
    </Security>
  );
};

export default App;
